import React from 'react'

const translations = {
  nl: {
    question: 'Hoe makkelijk was het om dit artikel te vinden op onze website?',
    score: ['Heel moeilijk', 'Moeilijk', 'Neutraal', 'Makkelijk', 'Heel makkelijk'],
    complexity: ['Heel moeilijk', 'Heel makkelijk'],
    change: 'Wijzig'
  },
  fr: {
    question: 'Avez-vous trouvé facilement cet article sur notre site web?',
    score: ['Très difficile', 'Difficile', 'Neutre', 'Facile', 'Très facile'],
    complexity: ['Très difficile', 'Très facile'],
    change: 'Modifier'
  }
}

export const SurveyBanner = ({ locale, selected, setSelected }) => {
  const lang = locale === 'fr' ? 'fr' : 'nl'
  return (
    <div className='survey-banner survey-banner-gaps'>
      <div>{translations[lang].question}</div>
      <SurveyButtons lang={lang} selected={selected} setSelected={setSelected} />
    </div>
  )
}

export const SurveyButtons = ({ lang, selected, setSelected }) => {
  const onSelect = e => {
    setSelected(e.target.id === '0' ? false : e.target.id)
  }
  if (selected) {
    return (
      <div className='survey-banner survey-banner-actions survey-banner-buttons'>
        <div className='survey-banner-button-text'>
          <div className='survey-banner survey-banner-button survey-banner-selected'>
            {translations[lang].score.indexOf(selected) + 1}
          </div>
          <div className='survey-banner survey-banner-actions'>{selected}</div>
        </div>
        <div className='survey-banner survey-banner-change' id='0' onClick={onSelect}>
          &nbsp;&nbsp;>&nbsp;&nbsp;{translations[lang].change}
        </div>
      </div>
    )
  }
  return (
    <>
      <div className='survey-banner survey-banner-actions'>
        <div className='survey-banner survey-banner-actions survey-banner-actions-complexity-easy'>
          {translations[lang].complexity[0]}
        </div>
        <div className='survey-banner survey-banner-actions survey-banner-buttons'>
          {translations[lang].score.map((item, i) => (
            <div key={item} className='survey-banner survey-banner-button' onClick={onSelect} id={item}>
              {i + 1}
            </div>
          ))}
        </div>
        <div className='survey-banner survey-banner-actions survey-banner-actions-complexity-hard'>
          {translations[lang].complexity[1]}
        </div>
      </div>
      <div className='survey-banner-complexity'>
        <div className='survey-banner-complexity-easy'>
          <div>{translations[lang].complexity[0]}</div>
        </div>
        <div className='survey-banner-complexity-hard'>
          <div>{translations[lang].complexity[1]}</div>
        </div>
      </div>
    </>
  )
}
